export default {
  mounted(el: HTMLElement, binding: any) {
    const max = binding.value || 30;
    const text = el.innerText.trim();
    if (text.length <= max) return;

    const half = Math.floor(max / 2);
    el.innerText = text.slice(0, half) + "..." + text.slice(-half);
  }
};
